/* eslint-disable */
import api from '@/api/api'
import { validarCNPJ, validarCPF } from '@/utils/validacoes'
import { v4 } from 'uuid'
import { checkError } from '../utils/checkError'
import { sendFile } from '../utils/sendFile'

const submit = async (template, planilha, error, table) => {
  const id_file = await sendFile(table)
  const submitPlan = planilha.data.map(row => {
    const isPf = validarCPF(row['0.2'].value)
    const isPj = validarCNPJ(row['0.5'].value)
    return {
      id: v4(),
      cod_centro: row['0.0'].value || null,
      pessoaFis: isPf,
      cpf: (isPf) ? row['0.2'].value || null : null,
      cnpj: (isPj) ? row['0.5'].value : null,
      nome: row['0.3'].value || null,
      razao_social: (isPj) ? row['0.4'].value : null,
      nome_fantasia: (isPj) ? row['0.4'].value : null,
      telefones: [row['0.6'].value, ((row['0.7'].value === '') ? null : row['0.7'].value)],
      cidade: row['0.8'].value || null,
      estado: row['0.9']?.value || null,
      pais: row['0.14'].value || null,
      logradouro: row['0.10'].value || null,
      bairro: row['0.11'].value || null,
      numero: row['0.12'].value || null,
      complemento: row['0.13'].value || null,
      cep: row['0.15'].value || null,
      sexo: '',
      rg: row['0.18'].value ? ((isPf) ?  row['0.5'].value.replace(/[a-z]/gi, '') : '' ) : '',
      cadastro: {
        produtor_id: '',
        cod_produtor_fornecedor: row['0.1'].value || null,
        ativo: row['0.16'].value && row['0.16'].value?.toLowerCase() === 'inativo' ? 0 : 1,
        tecnico: row['0.17'].value || null,
      },
      fazenda: {
        razao_social: (isPj) ? row['0.4'].value : 'FAZENDA DE ' + (isPf ? row['0.3'].value : row['0.4'].value),
        nome_fantasia: (isPj) ? row['0.3'].value : null,
        cnpj: (isPj && isPf) ? row['0.4'].value : null,
        inscricao_estadual: row['1.0'].value ? ((isPj && isPj && isPf) ? (!isNaN(row['1.0'].value.replace(/\D/g, '')) ? row['1.0'].value.replace(/\D/g, '') : '') : null) : '',
        latitude: row['1.1'].value,
        longitude: row['1.2'].value,
        cidade: row['0.8'].value || null,
        estado: row['0.9'].value || null,
        pais: row['0.14'].value || null,
        bairro: row['0.11'].value || null,
        logradouro: row['0.10'].value || null,
        numero: row['0.12'].value || null,
        cep: row['0.15'].value || null,
        complemento: row['0.13'].value || null,
        telefones: [row['0.6'].value, ((row['0.7'].value === '') ? null : row['0.7'].value)],
      },
    }
  })


  let envioPlan = []
  let retorno = []
  let nContador = 0
  let insert = 0
  let update = 0

  for (let i = 0; i < submitPlan.length; i++) {

    envioPlan.push(submitPlan[i])

    ++nContador

    if (nContador >= 500 || (i + 1) >= submitPlan.length) {

      try {
        let response = await api.cadastrarEntidade({ produtores: envioPlan, erro: error }, 'produtor/batch')
        insert += response[0].insert
        update += response[0].update
      }
      catch (e) {
        retorno = [...retorno, ...e.errors]
        insert += e.insert
        update += e.update
      }
      envioPlan = []
      nContador = 0
    }
  }
  envioLog(retorno.length, insert, update, id_file)

  if (retorno.length) {
    throw retorno
  }

  return retorno
}

const formatData = (data) => {
  let data_formatada = []
  data.forEach(row => data_formatada.push({
    '0.0': { value: row.cod_centro, ...checkError(row, 'cod_centro') },
    '0.1': { value: row.cadastro.cod_produtor_fornecedor, ...checkError(row, 'cadastro.cod_produtor_fornecedor') },
    '0.2': { value: row.cpf, ...checkError(row, 'cpf') },
    '0.3': { value: row.nome, ...checkError(row, 'nome') },
    '0.4': { value: row.razao_social, ...checkError(row, 'razao_social') },
    '0.5': { value: row.cnpj, ...checkError(row, 'cnpj') },
    '0.18': { value: row.rg, ...checkError(row, 'rg') },
    '0.6': { value: row.telefones[0], ...checkError(row, 'telefones') },
    '0.7': { value: row.telefones[1] },
    '0.8': { value: row.cidade, ...checkError(row, 'cidade') },
    '0.9': { value: row.estado, ...checkError(row, 'estado') },
    '0.14': { value: row.pais, ...checkError(row, 'pais') },
    '0.10': { value: row.logradouro, ...checkError(row, 'logradouro') },
    '0.11': { value: row.bairro, ...checkError(row, 'bairro') },
    '0.12': { value: row.numero, ...checkError(row, 'numero') },
    '0.13': { value: row.complemento },
    '0.15': { value: row.cep, ...checkError(row, 'cep') },
    '0.16': { value: row.cadastro.ativo === 1 ? 'Ativo' : 'Inativo', ...checkError(row, 'cadastro.ativo') },
    '0.17': { value: row.cadastro.tecnico, ...checkError(row, 'cadastro.tecnico') },
    '1.0': { value: row.inscricao_estadual, ...checkError(row, 'inscricao_estadual') },
    '1.1': { value: row.fazenda.latitude },
    '1.2': { value: row.fazenda.longitude },
  }))
  return data_formatada
}

async function envioLog (erros, insert, update, id_file) {
  const log = `Cadastrados ${insert}, Atualizados ${update}, Erros ${erros}`
  api.cadastrarEntidade({ log: log, tipo_integracao: 1, id_file: id_file }, 'integracaologs').then()
}

export default {
  submit,
  formatData,
}
